// External libraries
import React, { useState } from 'react';
import {
  CustomInputContainer,
  FloatingLabelInput,
  // @ts-expect-error untyped-import
} from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';

import {
  AddressAndEditContainer,
  EditButton,
  getCustomInputContainerStyleOverrides,
  inputContainerStyles,
  inputStyleOverrides,
} from './styles';
import { editButtonClick } from './handlers';

import {
  atomics,
  atomicsCi,
  atomicsDomain,
  atomicsFlows,
  atomicsStatus,
  atomicsTasks,
  atomicsViewNames,
} from '@/lib/atomics';
type PrimaryResidentialAddressProps = {
  value?: string;
};

export const PrimaryResidentialAddress = (
  props: PrimaryResidentialAddressProps,
): JSX.Element => {
  useMountLogging('PrimaryResidentialAddress');

  const [isEditFocused, setIsEditFocused] = useState(false);

  return (
    <>
      <AddressAndEditContainer
        data-testid="primaryResidentialAddressContainer"
        className="residential-address"
      >
        <CustomInputContainer
          inputId="primaryResidentialAddress"
          inputContainerStyleOverrides={getCustomInputContainerStyleOverrides(
            isEditFocused,
          )}
        >
          {() => (
            <>
              <FloatingLabelInput
                id="primaryResidentialAddress"
                label={getContent('fieldLabels.primaryResidentialAddress')}
                required={false}
                value={props.value}
                containerStyleOverrides={inputContainerStyles}
                inputStyleOverrides={inputStyleOverrides}
                data-testid="primaryResidentialAddressInput"
                readOnly
                {...props}
              />
              <EditButton
                id="editPrimaryResidentialAddressButton"
                type="button"
                data-testid="primaryResidentialAddressEditButton"
                onClick={editButtonClick}
                aria-label={`${getContent('buttons.edit')} ${getContent(
                  'fieldLabels.primaryResidentialAddress',
                )}`}
                onFocus={() => {
                  setIsEditFocused(true);
                }}
                onBlur={() => {
                  setIsEditFocused(false);
                }}
                data-atomic-wait-domain={atomicsDomain}
                data-atomic-wait-flow={atomicsFlows.guestAndSignup}
                data-atomic-wait-intent={
                  atomicsCi.clickEditResidentialAddressButton
                }
                data-atomic-wait-task={atomicsTasks.addResidentialAddress}
                data-atomic-wait-viewname={atomicsViewNames.ryp}
              >
                {getContent('buttons.edit')}
              </EditButton>
            </>
          )}
        </CustomInputContainer>
      </AddressAndEditContainer>
      <atomics.MarkUIReady
        viewName={atomicsViewNames.ryp}
        status={atomicsStatus.ok}
        domain={atomicsDomain}
        task={atomicsTasks.addResidentialAddress}
      />
    </>
  );
};
